// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__18kOl","col":"CardReaderDesc_col__2w6CW","label":"CardReaderDesc_label__fT3wE"};